{#if config.isCourseTypeSelfPaced}
    <TwoColumnPage>
        <div slot="sidebar">
            <CourseInfoBox {...config.courseInfoBox}>
                <div class="itsl-course-info-box__progress-bar" slot="custom">
                    {#if !config.canEdit && config.canViewProgressBar}
                    <span class="itsl-course-info-box__progress-bar__title">{i18n.progress}</span>
                    <ProgressBar
                        accessibleText={i18n.completedXofYPlans}
                        displayText={i18n.completedXofYPlans}
                        max={config.numTotalPlans}
                        value={numbOfCompletedPlans}
                    />
                    {/if}
                </div>
            </CourseInfoBox>
        </div>
        <div slot="content">
            <Banner close={i18n.close} text={config.bannerText} type="{bannerType}" bind:visible={showBanner} />
            <HeadingRow
                {config}
                headerText={i18n.plansHeader}
                {i18n}
                {optionItems}
                {selectedAction}
                {showStopSharingPlannerConfirmModal}
                {stopSharingModalClicked}
            />
            <SelfPacedPlanTabs />
        </div>
    </TwoColumnPage>
{:else}
    <Banner close={i18n.close} text={config.bannerText} type="{bannerType}" bind:visible={showBanner} />
    <HeadingRow
        {config}
        {i18n}
        {optionItems}
        {selectedAction}
        {showStopSharingPlannerConfirmModal}
        {stopSharingModalClicked}
    />
    {#if !isSelfPacedCourse}
        <PlanTabs />
    {:else}
        <SelfPacedPlanTabs />
    {/if}
{/if}

<script>
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';
    import TwoColumnPage from '@itslearning/prometheus/assets/templates/TwoColumnPage/v1/TwoColumnPage.svelte';

    import CourseInfoBox from "@its-ui/course-info-box/src/lib/App/App.svelte";
    import { stopSharingPlanner, completedPlans } from "@its-ui/planner-common/api";
    import config from "@its-ui/planner-common/config";
    import { columnTypes, columnVisibility, readyMadeContentImportStatus } from "@its-ui/planner-common/constants";
    import i18n from "@its-ui/planner-common/i18n";
    import ProgressBar from "@its-ui/planner-common/components/ProgressBar/ProgressBar.svelte";

    import HeadingRow from "./HeadingRow.svelte";
    import PlanTabs from "../PlanTabs/PlanTabs.svelte";
    import SelfPacedPlanTabs from "../SelfPacedPlanTabs/SelfPacedPlanTabs.svelte";

    const isSelfPacedCourse =
        config.columnVisibilities[columnTypes.Date] === columnVisibility.Nobody;
    const canStopSharingPlanner = config.canSharePlanner && config.canUpdateSharingPlanner;
    const stopSiteSharingSelectValue = 1;

    const numberOfIterations = 5;
    let getNoOfCompletedPlansSuccess = false;
    let showStopSharingPlannerConfirmModal = false;
    let stopSharingPerformed = false;
    $: numbOfCompletedPlans = config.numCompletedPlans;
    $: showBanner = config.bannerText !== "";
    $: bannerType = config.readyMadeContentImportStatus === readyMadeContentImportStatus.fullyImported ? "info" : "warning";

    $: optionItems = getActions();

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    $: if(!config.canEdit && config.canViewProgressBar && !getNoOfCompletedPlansSuccess) {
        (async () => {
            try {
                await delay(200);

                for (let i = 0; i < numberOfIterations; i++) {
                    const completedPlansResponse = await completedPlans(config.courseId);

                    if (completedPlansResponse !== numbOfCompletedPlans)
                    {
                        numbOfCompletedPlans = completedPlansResponse;
                        getNoOfCompletedPlansSuccess = true;
                        break;
                    }

                    if (i === numberOfIterations) {
                        getNoOfCompletedPlansSuccess == true;
                    }

                    await delay(100);
                }

            } catch (err) {
                console.error('API call failed', err);
            }
        })();
    }

    $: if (stopSharingPerformed) {
        optionItems = getActions();
        stopSharingPerformed = false;
    }

    function selectedAction(event) {
        switch (event.detail.data) {
            case stopSiteSharingSelectValue:
                showStopSharingPlannerConfirmModal = true;
                break;
        }
    }

    function getActions() {
        const options = [];

        options.push({
            icon: "",
            label: i18n.planSettings,
            link: true,
            url: config.settingPageUrl,
            target: "_self"
        });

        if (canStopSharingPlanner && !stopSharingPerformed) {
            options.push({
                icon: "",
                label: i18n.stopSiteSharing,
                link: false,
                target: "_self",
                value: stopSiteSharingSelectValue
            });
        }

        if (config.canSharePlanner) {
            options.push({
                icon: "",
                label:
                    config.canUpdateSharingPlanner && !stopSharingPerformed
                        ? i18n.updateSiteSharing
                        : i18n.shareWithSites,
                link: true,
                url: config.shareToLibraryPageUrl,
                target: "_self"
            });
        }

        options.push({
            icon: "",
            label: i18n.importExport,
            link: true,
            url: config.importExportPageUrl,
            target: "_self",
        });

        return [{ options: options }];
    }

    function stopSharingModalClicked(event) {
        if (event.detail.confirmed === true) {
            stopSharingPlanner(config.plannerShareableObjectId).then(() => {
                stopSharingPerformed = true;
            });
        }

        showStopSharingPlannerConfirmModal = false;
    }
</script>
